import { getFixedT, TFunction } from "i18next";
import { ReportRequest20DTO } from "../Reports/ReportRequests_20_DTO";
import { CopilotConversationDTO } from "./copilotConversationDTO";
import ReportRequestDTO from "../Reports/ReportRequestDTO";
import { PrivacyFramework } from "models/processingActivity";

export class CopilotProcessingActivityDTO {
  processingActivityId: number;

  conversation: CopilotConversationDTO;

  report20Dto: ReportRequest20DTO;

  constructor(privacyFramework: PrivacyFramework) {
    this.processingActivityId = 0;
    this.conversation = new CopilotConversationDTO();
    // Use English, because the prompt gives better results if the fieldnames in the prompt match the report fields exactly
    const tEn: TFunction<string[]> = getFixedT('en', ['processingActivity', 'processingActivities']);
    this.report20Dto = new ReportRequest20DTO(new ReportRequestDTO(undefined), tEn, privacyFramework);
  }
}